<template>
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2 0H7V4C7 4.5625 7.4375 5 8 5H12V14C12 15.125 11.0938 16 10 16H2C0.875 16 0 15.125 0 14V2C0 0.90625 0.875 0 2 0ZM8 0L12 4H8V0ZM6.75 12.75V9.5625L7.71875 10.5312C8 10.8438 8.46875 10.8438 8.78125 10.5312C9.0625 10.25 9.0625 9.78125 8.78125 9.46875L6.53125 7.21875C6.21875 6.9375 5.75 6.9375 5.46875 7.21875L3.21875 9.46875C2.90625 9.78125 2.90625 10.25 3.21875 10.5312C3.5 10.8438 3.96875 10.8438 4.28125 10.5312L5.25 9.5625V12.75C5.25 13.1875 5.5625 13.5 6 13.5C6.40625 13.5 6.75 13.1875 6.75 12.75Z"
            fill="white" />
    </svg>
</template>

<script>
export default {
    name: 'UploadFileIcon'
}
</script>